<template>
    <div class="relative overflow-hidden">
        <div class="animated_line" :style="initialStyle">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'animated-text-line',
        props:{
            direction:{
                type: String, //XYZ
                default:'Y'
            },
            offset:{
                type: String,
                default:'-110%'
            },
            delay:{
                type: Number,
                default:1000 //ms
            }
        },
        data(){
          return{
              reveal:false
          }
        },
        computed:{
            initialStyle(){
                return this.reveal ?
                    'transform: translate(0,0);'
                    :
                    'transform:translate'+this.direction+'('+this.offset+')';
            }
        },
        mounted() {
            setTimeout(()=>{
                this.reveal=true;
            },this.delay);
        }
    }
</script>

<style>
    .animated_line{
        transition: transform 1s ease-out;
    }
</style>